export default "__VITE_ASSET__BsQFfJO2__"